export const MASTER_VOLUME_CHARTS_SPECIFIC: Array<undefined | string> = ['bubble']
export const MASTER_VOLUME_CHARTS: Array<undefined | string> = ['radar', 'bubble', 'pie', 'doughnut', 'polarArea']
export const MASTER_VOLUME_CHARTS_SIMPLE: Array<undefined | string> = MASTER_VOLUME_CHARTS.filter(
    (chart) => MASTER_VOLUME_CHARTS_SPECIFIC.indexOf(chart) === -1
)
